import { render, staticRenderFns } from "./edit-estimated-exchange-rate.vue?vue&type=template&id=5ad80eaa"
import script from "./edit-estimated-exchange-rate.vue?vue&type=script&lang=ts"
export * from "./edit-estimated-exchange-rate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports